import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class LoadingService {
    constructor() {
        this.isLoading = new BehaviorSubject(false);
        this.loadingStatus = false;
        this.isLoading.subscribe((status) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loadingStatus = yield status;
        }));
    }
}
LoadingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoadingService_Factory() { return new LoadingService(); }, token: LoadingService, providedIn: "root" });
